import Box, { type BoxProps } from "@mui/material/Box";
import { forwardRef } from "react";

import { mergeSxProps } from "../Mui";
import { type ProblematicMuiPackagingProps } from "../Mui/types";

/**
 * @deprecated Use the Image component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export interface ImageProps extends Omit<
  ProblematicMuiPackagingProps<BoxProps>,
  "component" | "children"
> {
  src: string;
  alt: string;
}

/**
 * @deprecated Use the Image component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export const Image = forwardRef((props: ImageProps, ref) => {
  const { sx, width, height, ...boxProps } = props;

  return (
    <Box
      component="img"
      {...boxProps}
      ref={ref}
      sx={mergeSxProps(
        {
          /**
           * Box does not pass `width` and `height` through.
           * Instead, pass it in via `sx`
           */
          width,
          height,
        },
        sx
      )}
    />
  );
});

Image.displayName = "Image";
